export enum ContractTier {
  Free = 'Free',
  Enterprise = 'Enterprise',
  RMSubscription = 'RMSubscription' // this does not have a space - do not confuse with the display value above
}

export enum PricingPlanTier {
  Enterprise = 'Enterprise',
  Pro = 'Pro',
  Starter = 'Starter',
  Free = 'Free',
  RMSubscription = 'RMSubscription' // yes, the space there is intentional because this is intended as a display name
}

export type ContractItem = {
  company_id: string
  start: string
  end?: string
  is_trial: boolean
  has_reliability_management: boolean
  has_fault_injection: boolean
  limit_policy?: string
  tier: ContractTier
  contract_id: string
  pricing_plan_id?: string
  pricing_plan_name?: PricingPlanTier
  pricing_plan_overrides?: string
  pricing_plan_add_ons_count?: number
  created_at: string
  updated_at: string
}

export type Contract = {
  contract_id: string
  items: ContractItem[]
}
